var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "text-tooltip" },
    [
      _c(
        "el-tooltip",
        {
          staticClass: "item",
          attrs: {
            effect: "dark",
            disabled: _vm.isShowTooltip,
            placement: "top",
          },
        },
        [
          _c("div", {
            attrs: { slot: "content" },
            domProps: { innerHTML: _vm._s(_vm.content) },
            slot: "content",
          }),
          _c(
            "p",
            {
              staticClass: "over-flow",
              style: { width: `${_vm.fixedWidth}px` },
              on: {
                mouseover: function ($event) {
                  return _vm.onMouseOver(_vm.refName)
                },
              },
            },
            [
              _c("span", {
                ref: _vm.refName,
                domProps: { innerHTML: _vm._s(_vm.content || "-") },
              }),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }